import React from 'react';
import BaseTablePage from '../../elements/BaseTablePage'
import Pagination from '../../elements/Pagination'

import { ChanceTableUI } from './ChanceTableUI'



import { FixChanceTableUI } from './FixChanceTableUI'

//import { GhorePrizePage } from '../../components/GhorePrizePage'


export class ChanceTable extends BaseTablePage {

  constructor(props) {
    super(props);
    this.getDataUrl = "api/v1/GetChance?offset=";
    this.getExcelUrl = "/api/v1/GetChanceReportExcel";

    ///fix
    if(this.props.ceremonyLotteryKind==1)
    {
      this.getDataUrl = "api/v1/GetFixChance?offset=";
      this.getExcelUrl = "/api/v1/GetFixChanceReportExcel";
    }

    this.className = "ChanceReport";
    this.state.mode = "table";
    this.state.searchData = { };
    this.headers["ceremonyId"] = this.props.ceremonyId;


  }


  render() {
    //  if (!this.state.isLoaded) {
    //  return <div className="box-body"> در حال بارگذاری</div>;
    // }

    //console.log()


      var tt=  <ChanceTableUI data={this.state.data} onViewClick={this.onViewClick} />;

      ///fix
      if(this.props.ceremonyLotteryKind==1)
      {  
            var tt= <FixChanceTableUI data={this.state.data} onViewClick={this.onViewClick} />;
      }
    
    return (
      <div className="container">
        <input type="button" className="btn btn-primary" value="خروجی اکسل" onClick={()=>this.onExcelButtonClick({})} />
        <br/>
        {tt}
        <Pagination pageNumber={this.state.pageNumber} count={this.state.count} perPageCount={this.state.pageSize} onChange={this.handleChangePage} />
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/tables/chance/ChanceTable.js